import { render, staticRenderFns } from "./dataPortrait.vue?vue&type=template&id=9bdd5146&scoped=true&"
import script from "./dataPortrait.vue?vue&type=script&lang=js&"
export * from "./dataPortrait.vue?vue&type=script&lang=js&"
import style0 from "./dataPortrait.vue?vue&type=style&index=0&id=9bdd5146&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdd5146",
  null
  
)

export default component.exports